import React from 'react'
import { Grid, Typography, Divider, Box, makeStyles } from '@material-ui/core'
import BaseFilterModal from '../../../components/hooks/BaseFilterModal'
import { exportFormatedMoney } from '../../../util/utils'
import colors from '../../../assets/colors'

const useStyles = makeStyles(theme => ({
  section: {
    //
  },
  sectionTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(2),
    color: colors.primary,
    fontSize: '18px',
  },
  comparisonContainer: {
    display: 'flex',
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  columnBefore: {
    flex: 1,
    padding: theme.spacing(2),
    backgroundColor: '#fff3e0',
    borderRadius: '1.2em',
    border: '1px solid #ffb74d',
  },
  columnAfter: {
    flex: 1,
    padding: theme.spacing(2),
    backgroundColor: '#e8f5e9',
    borderRadius: '1.2em',
    border: '1px solid #81c784',
  },
  columnTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(1),
    fontSize: '16px',
  },
  field: {
    marginBottom: theme.spacing(1),
  },
  label: {
    fontWeight: 500,
    color: colors.textPrimary,
  },
  value: {
    marginLeft: theme.spacing(1),
    color: colors.textPrimary,
  },
  divider: {
    margin: theme.spacing(2, 0),
  },
}))

const DetailsModal = ({ open, onClose, item }) => {
  const classes = useStyles()

  if (!item) return null

  const getOptionTypeLabel = type => {
    const types = {
      1: 'Quadrado',
      2: 'Redondo',
    }
    return types[type] || type
  }

  const renderOptions = options => {
    if (!options) return 'N/A'
    return (
      <Box>
        {options.type && (
          <Typography variant="body2" className={classes.field}>
            <span className={classes.label}>Tipo:</span>
            <span className={classes.value}>
              {getOptionTypeLabel(options.type)}
            </span>
          </Typography>
        )}
        {parseFloat(options.base) > 0 && (
          <Typography variant="body2" className={classes.field}>
            <span className={classes.label}>Base:</span>
            <span className={classes.value}>{options.base}</span>
          </Typography>
        )}
        {parseFloat(options.altura) > 0 && (
          <Typography variant="body2" className={classes.field}>
            <span className={classes.label}>Altura:</span>
            <span className={classes.value}>{options.altura}</span>
          </Typography>
        )}
        {parseFloat(options.diametro) > 0 && options.diametro !== '0.0' && (
          <Typography variant="body2" className={classes.field}>
            <span className={classes.label}>Diâmetro:</span>
            <span className={classes.value}>{options.diametro}</span>
          </Typography>
        )}
        {options.observation ? (
          <Typography variant="body2" className={classes.field}>
            <span className={classes.label}>Observação:</span>
            <span className={classes.value}>{options.observation}</span>
          </Typography>
        ) : (
          <></>
        )}
      </Box>
    )
  }

  return (
    <BaseFilterModal
      open={open}
      handleOpen={onClose}
      title={`Detalhes da Catalogação - OS #${item.service_id_laundry_client}`}
      hiddenHelpButton
    >
      <Grid item xs={12} style={{ width: '800px', maxWidth: '90vw' }}>
        <Box className={classes.section}>
          <Typography className={classes.sectionTitle}>
            Informações Gerais
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="body2" className={classes.field}>
                <span className={classes.label}>Serviço:</span>
                <span className={classes.value}>
                  {item.serviceItem?.serviceType?.name || 'N/A'}
                </span>
              </Typography>
            </Grid>
          </Grid>
        </Box>

        <Divider className={classes.divider} />

        <Box className={classes.section}>
          <Typography className={classes.sectionTitle}>
            Comparação: Antes vs Depois da Catalogação
          </Typography>

          <Box className={classes.comparisonContainer}>
            <Box className={classes.columnBefore}>
              <Typography variant="subtitle1" className={classes.columnTitle}>
                Antes da Catalogação
              </Typography>

              <Typography variant="body2" className={classes.field}>
                <span className={classes.label}>Quantidade:</span>
                <span className={classes.value}>{item.quantity}</span>
              </Typography>

              <Typography variant="body2" className={classes.field}>
                <span className={classes.label}>Total:</span>
                <span className={classes.value}>
                  {exportFormatedMoney(item.final_value)}
                </span>
              </Typography>

              <Divider style={{ margin: '12px 0' }} />

              {renderOptions(item.options)}
            </Box>

            <Box className={classes.columnAfter}>
              <Typography variant="subtitle1" className={classes.columnTitle}>
                Depois da Catalogação
              </Typography>

              <Typography variant="body2" className={classes.field}>
                <span className={classes.label}>Quantidade:</span>
                <span className={classes.value}>
                  {item.catalog_quantity || 'N/A'}
                </span>
              </Typography>

              <Typography variant="body2" className={classes.field}>
                <span className={classes.label}>Total:</span>
                <span className={classes.value}>
                  {item.catalog_final_value
                    ? exportFormatedMoney(item.catalog_final_value)
                    : 'N/A'}
                </span>
              </Typography>

              <Divider style={{ margin: '12px 0' }} />

              {renderOptions(item.catalog_options)}
            </Box>
          </Box>
        </Box>
      </Grid>
    </BaseFilterModal>
  )
}

export default DetailsModal
